const example = {
    view: 'Список',
    brand: 0,
    store: 0,
    address: 0,
    code: 0,
    region: 0,
    city: 0,
    booking: 0,
    moderation: 0,
    sort: 'По дате создания',
    paginate: 10,
    device: [{ name: 'рекламный ТВ', icon: '/images/bi_tv.svg' }],
    search: 'Селект с поиском',
    noSearch: 'Селект без поиска',
    group: 'Выбрать группу устройств',
    source: 'Указать вручную'
}
export default example;
